export default "__VITE_ASSET__d5427e5c__"